import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import { Card } from "./UI";

export const MiniBarChart = ({ data }) => {
  const paguMax = data?.length > 0 ? Math.max(...data.map(d => Number(d.pagu || 0))) : 1;
  const realMax = data?.length > 0 ? Math.max(...data.map(d => Number(d.realization || 0))) : 1;
  return (
    <div style={{ display:"flex", alignItems:"flex-end", gap:6, height:100, padding:"0 4px" }}>
      {data?.map((d,i) => (
        <div key={i} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", gap:2 }}>
          <div style={{ width:"100%", display:"flex", alignItems:"flex-end", gap:2, height:80 }}>
            <div style={{ flex:1, background:"#DBEAFE", borderRadius:"3px 3px 0 0", height:`${(Number(d.pagu||0)/paguMax)*100}%`, minHeight:2 }}/>
            <div style={{ flex:1, background:"#2563EB", borderRadius:"3px 3px 0 0", height:`${(Number(d.realization||0)/realMax)*100}%`, minHeight:2 }}/>
          </div>
          <span style={{ fontSize:9, color:"#9CA3AF", fontWeight:500 }}>{d.bulan}</span>
        </div>
      ))}
    </div>
  );
};

export const StatCard = ({ icon, label, value, sub, trend, color="#2563EB" }) => (
  <Card>
    <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between" }}>
      <div>
        <p style={{ margin:"0 0 8px", fontSize:12, color:"#6B7280", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.04em" }}>{label}</p>
        <p style={{ margin:0, fontSize:22, fontWeight:700, color:"#111827" }}>{value}</p>
        {sub && <p style={{ margin:"4px 0 0", fontSize:12, color:"#9CA3AF" }}>{sub}</p>}
        {trend !== undefined && (
          <div style={{ display:"flex", alignItems:"center", gap:4, marginTop:6 }}>
            {trend >= 0 ? <TrendingUp size={12} color="#10B981"/> : <TrendingDown size={12} color="#EF4444"/>}
            <span style={{ fontSize:11, color:trend>=0?"#10B981":"#EF4444", fontWeight:600 }}>
              {trend>=0?"+":""}{trend}% bulan ini
            </span>
          </div>
        )}
      </div>
      <div style={{ width:44, height:44, borderRadius:12, background:color+"15",
        display:"flex", alignItems:"center", justifyContent:"center" }}>
        {React.cloneElement(icon, { size:22, color })}
      </div>
    </div>
  </Card>
);
